import React from "react";

const PartnerView = () => null;

export default PartnerView;
